import { SidePopupLayout } from "src/component/SidePopupLayout";
import { ReactElement, useState } from "react";
import {
  AbsoluteContainer,
  AppLabel,
  AppSpan,
  AppText,
  Button,
  CustomContainer,
  FlexRow,
  Form,
  FormGroup,
  FormGroupWithIcon,
  GridContainer,
  ScreenTitle,
  Switch,
} from "src/style";
import { Features, IExpenseCategory } from "src/model";
import { expenseCategories } from "src/provider/config/constant";
import {
  moneyFormat,
  handleAmountChange,
  handleTypeNumberControl,
} from "@src/utils/utility";
import { FiChevronDown } from "react-icons/fi";
import { HiOutlineUser } from "react-icons/hi";

interface SendProps {
  close: () => void;
}
const CbpSendMoney = ({ close }: SendProps) => {
  const [view, setView] = useState("send-money");
  const [isLoading, setIsLoading] = useState(false);
  const [amount, setAmount] = useState("");
  const [input, setInput] = useState("");
  const handleInput = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    setAmount(value);
  };
  return (
    <>
      {view === "send-money" && (
        <SidePopupLayout close={close}>
          {isLoading && (
            <AbsoluteContainer
              top="0"
              left="0"
              zIndex="3"
              width="100"
              sizeUnit="%"
              height="full"
            >
              <GridContainer
                height="100"
                hUnit="%"
                bgColor="rgba(255, 255, 255, 0.5)"
              >
                <AppSpan
                  textSize="4"
                  color="#0D968F"
                  className="fa fa-spinner fa-spin"
                />
              </GridContainer>
            </AbsoluteContainer>
          )}
          <ScreenTitle textSize="2.2" fontWeight="700">
            Send Money
          </ScreenTitle>
          <AppText fontWeight="100" color="#667085" fontFamily='Gilmer-Semi-Bold' topMargin="2">Enter the amount you want to convert</AppText>


          <Form
            // onSubmit={handleProceed}
            style={{ height: "87%" }}
            className="overflow-y-container"
          >
            <FormGroup topMargin="1">
              <label>You Send</label>
              <input
                placeholder="Enter Amount"
                name="amount"
                autoComplete="off"
                value={amount}
                onChange={handleInput}
                required
              />
            </FormGroup>

            <FlexRow justifyContent="flex-end">
              <Button
                width="8.8"
                height="4"
                topMargin="2.5"
                borderColor="#0D968F"
                hoverBgColor="#fff"
                hoverColor="#0D968F"
                titleSize="1.4"
              >
                Proceed
              </Button>
            </FlexRow>
          </Form>
        </SidePopupLayout>
      )}
    </>
  );
};

export default CbpSendMoney;
